/** Phân quyền — tài khoản (trang account) */
export const ACCOUNT_PERMISSION_CODES = {
  /** Tra cứu dùng chung (dropdown, danh mục picker) — gắn mọi nhân viên nội bộ. */
  WEB_BH_ACCOUNT_CHUNG: 'WEB_BH_ACCOUNT_CHUNG',
  WEB_BH_ACCOUNT_LIST: 'WEB_BH_ACCOUNT_LIST',
  WEB_BH_ACCOUNT_EDIT: 'WEB_BH_ACCOUNT_EDIT',
} as const

export type AccountPermissionCode =
  (typeof ACCOUNT_PERMISSION_CODES)[keyof typeof ACCOUNT_PERMISSION_CODES]

export const accountPermissionCodeValues = Object.values(ACCOUNT_PERMISSION_CODES)

export const ACCOUNT_READ_PERMISSIONS = [
  ACCOUNT_PERMISSION_CODES.WEB_BH_ACCOUNT_CHUNG,
  ACCOUNT_PERMISSION_CODES.WEB_BH_ACCOUNT_LIST,
] as const

export const ACCOUNT_MUTATE_PERMISSIONS = [
  ACCOUNT_PERMISSION_CODES.WEB_BH_ACCOUNT_EDIT,
] as const
